import { CelebrationsSeniorityPageTemplate } from "./template";
import { useCelebrationsSeniorityPage } from "./logic";

export const CelebrationsSeniorityPage = () : JSX.Element => {
    const props = useCelebrationsSeniorityPage();

    return (
        <CelebrationsSeniorityPageTemplate {...props}/>
    )
}